export default {"src":"/_next/static/media/Navbar_Menu.930b4ee0.svg","height":20,"width":36,"blurWidth":0,"blurHeight":0};